module.exports = __webpack_public_path__ + "static/media/profi_grey.87614a29.svg";